export function toHumanSize(bytes: number, dp = 1) {
  let size = bytes;
  const thresh = 1024;

  if (Math.abs(size) < thresh) {
    return `${size} B`;
  }

  const units = ['kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

  let u = -1;
  const r = 10 ** dp;

  do {
    size /= thresh;
    u += 1;
  } while (Math.round(Math.abs(size) * r) / r >= thresh && u < units.length - 1);

  return `${size.toFixed(dp)} ${units[u]}`;
}

export const getFileDataUrl = async (blob: Blob): Promise<string> => {
  const fileReader = new FileReader();

  return new Promise((resolve) => {
    fileReader.onload = ({ target }) => {
      resolve(target?.result as string);
    };
    fileReader.readAsDataURL(blob);
  });
};

export const downloadFile = (url: string, filename: string) => {
  const downloadLink = document.createElement('a');

  downloadLink.href = url;
  downloadLink.download = filename;
  document.body.appendChild(downloadLink);
  downloadLink.click();
  document.body.removeChild(downloadLink);

  setTimeout(() => URL.revokeObjectURL(url), 100);
};
